import { Box } from '@chakra-ui/react';
import OrderHoverCheckbox from './OrderHoverCheckbox';

interface OrderRoColumnCheckboxSlotProps {
    orderId: string;
    rowIndex: number;
    isChecked: boolean;
    onToggle: (orderId: string, rowIndex: number, shiftKey: boolean) => void;
}

const OrderRoColumnCheckboxSlot = ({
    orderId,
    rowIndex,
    isChecked,
    onToggle,
}: OrderRoColumnCheckboxSlotProps) => (
    <Box flexShrink={0} onClick={(e) => e.stopPropagation()}>
        <OrderHoverCheckbox
            orderId={orderId}
            isChecked={isChecked}
            rowIndex={rowIndex}
            onToggle={onToggle}
        />
    </Box>
);

export default OrderRoColumnCheckboxSlot;
